import { useFormContext } from 'react-hook-form'
import { DatePickerInput } from '../../../../inputs/date-picker-input'
import { useTranslation } from 'react-i18next'
import { ReportDefinitionFilter } from '../../../../generated/graphql'
import { ReportForm } from '../../report-form'

type Props = {
  dateEndKey: keyof Pick<ReportDefinitionFilter, 'stockDateEnd'>
  required?: boolean
}

export const DateEndPickerInput = (props: Props) => {
  const { control } = useFormContext<ReportForm>()
  const { t } = useTranslation('reports')

  return (
    <DatePickerInput
      required={props.required}
      control={control}
      label={t('create_dialog.date_end')}
      name={`reportdefinition.filters.${props.dateEndKey}`}
      transform={{ output: (value) => value?.endOf('day').toJSON() }}
    />
  )
}
